import { upperFirst } from 'lodash-es';

import { Badge } from 'src/common/primitives/Badge';

export function SkillBadge({ skill }: { skill: string }): JSX.Element {
  const formattedSkill = upperFirst(skill);
  return <Badge label={formattedSkill} color="blue" />;
}
